module.exports = __webpack_public_path__ + "img/honor03.20a4611f.webp";